<div class="flex flex-column gap-3">
  <div *ngFor="let option of options" class="field-checkbox">
      <p-radioButton  [inputId]="option.key" name="category" [value]="option" [(ngModel)]="ngModel"></p-radioButton>
      <label [for]="option.key" class="ml-2">{{ option.name }}</label>
  </div>
</div>
